import { render, staticRenderFns } from "./TypingIndicator.vue?vue&type=template&id=2bed6fc2"
import script from "./TypingIndicator.vue?vue&type=script&lang=js"
export * from "./TypingIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports